export const ACTIVE_MIXPANEL_TOKEN = {
  client: process.env.REACT_APP_CLIENT_MIXPANEL_TOKEN,
  provider: process.env.REACT_APP_WEBSITE_MIXPANEL_TOKEN,
  signup: process.env.REACT_APP_WEBSITE_MIXPANEL_TOKEN,
}[process.env.REACT_APP_FAY_APP ?? ""];
